<div class="rounded-4 bg-white shadow-sm p-3 attribute-card d-flex flex-column">
  <div class="d-flex mb-3 align-items-center">
    <h3 class="fs-24 mb-0 me-2">{{ attributeList()?.name }}</h3>
    <i
      class="bi bi-plus-circle fs-20 me-1"
      [ngClass]="!attributeList()?.validate ? 'text-muted' : 'text-primary'"
      (click)="attributeList()?.validate ? openAddAttributeValue() : null"
      role="button"
    ></i>
    @if (!attributeList()?.validate) {
      <i
        class="bi bi-exclamation-triangle text-danger fs-20 me-1 ms-1"
        [ngbPopover]="attributeList()?.validate ? '' : 'Attribute is not validated'"
        [triggers]="'hover'"
      ></i>
    }
    <span class="ms-auto d-flex align-items-center gap-2">
      <div class="position-relative">
        <svg-icon
          [name]="'search-topbar'"
          class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-20"
        ></svg-icon>
        <input class="form-control ps-5 py-2 rounded-5" type="text" placeholder="Search" [(ngModel)]="search" />
      </div>

      <div ngbDropdown container="body" placement="bottom-end">
        <i class="bi bi-three-dots-vertical fs-20" ngbDropdownToggle></i>
        <div ngbDropdownMenu>
          <button ngbDropdownItem (click)="addAttributeType()">Edit</button>
          <!-- <button ngbDropdownItem (click)="showConfirmPopup(attributeList().id!); selectedAttributeTypeId.set(attributeList()?.id)">Delete</button> -->
          <button ngbDropdownItem (click)="selectedAttributeTypeId.set(attributeList()!.id); deleteAttributeType()">
            Delete
          </button>
        </div>
      </div>
    </span>
  </div>

  @if ((attributeValues()?.slice(0, toggleAttributeValues()))!.length > 0) {
    <div class="flex-fill overflow-y-auto pe-2 pb-3">
      <div class="d-flex flex-column gap-2">
        @for (attributeValue of attributeValues()?.slice(0, toggleAttributeValues()); track attributeValue?.id) {
          <div class="rounded-3 px-2 py-1 border d-flex align-items-center">
            <p class="mb-0 fs-14">{{ attributeValue.value }}</p>
            <div class="ms-auto">
              <div class="d-flex mt-1 align-items-center">
                <!-- <p class="me-2 mb-0 fs-14">Validate</p> -->
                <!-- <p-toggleswitch formControlName="enabled" /> -->
                <!-- <p-toggleswitch [(ngModel)]="attributeValue.enabled" /> -->
                <i
                  class="bi bi-trash text-danger fs-14 ms-2 px-2"
                  (click)="selectedAttributeValueId.set(attributeValue.id); deleteAttributeValue()"
                  role="button"
                  ngbTooltip="Delete"
                ></i>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    @if (attributeValues()!.length > 10) {
      <div class="pt-3 border-top border-gray-300 fs-14" role="button">
        <p
          (click)="
            toggleAttributeValues() === 10
              ? toggleAttributeValues.set(attributeValues()!.length)
              : toggleAttributeValues.set(10)
          "
          class="text-center mb-0"
        >
          <i class="{{ toggleAttributeValues() === 10 ? 'bi bi-chevron-down' : 'bi bi-chevron-up' }} me-1"> </i>
          Show {{ toggleAttributeValues() === 10 ? attributeValues()!.length - 10 : '' }}
          {{ toggleAttributeValues() === 10 ? 'More ' : 'Less ' }}
        </p>
      </div>
    }
  } @else {
    <div class="flex-fill">
      <div class="bg-gray-200 rounded-3 p-3 h-100">
        <div class="d-flex align-items-center justify-content-center flex-column h-100">
          <p class="mb-2">Start adding Attribute Values</p>
          <button class="btn btn-primary btn-h35" (click)="openAddAttributeValue()">
            <i class="bi bi-plus-circle"></i>Add Attribute Value
          </button>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #addAttributeValue let-modal>
  <div class="modal-header">
    <h2 class="modal-title">Add Attribute Value</h2>
    <span (click)="modal.close('Save click')" role="button">
      <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
    </span>
  </div>

  <div class="modal-body">
    <lib-attribute-value-form
      [submitButton]="submitButton()"
      [selectedAttributeValueId]="selectedAttributeValueId()"
      [selectedAttributeTypeId]="attributeList()!.id"
    >
    </lib-attribute-value-form>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="modal.close('Save click')" class="btn btn-secondary">Cancel</button>
    <button type="button" (click)="submitButton.set(!submitButton())" class="btn btn-primary">Save</button>
  </div>
</ng-template>
